import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Img, Button} from '@chakra-ui/react'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {getGlobalLink} from '../../../../utils/contentstack-utils'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import {useProducts} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {Link} from 'react-router-dom'

const InstaStorySlide = ({button, image, styles}) => {
    const damImage = useDamImage(image)
    const imageSrc = damImage?.url || image?.url
    const categoriesData = useGetCategoriesData()
    const {locale} = useMultiSite()

    const {data: productsData} = useProducts(
        {
            parameters: {
                ids: button?.productsfcc?.data?.length > 0 ? button.productsfcc.data[0].id : '',
                expand: ['availability', 'images'],
            },
            headers: {'x-debug': 'plp-insta-story-slide'},
        },
        {enabled: button?.productsfcc?.data?.length > 0},
    )

    const {url, label, isAbsolute} = getGlobalLink({
        link: button,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })

    const buttonProps = isAbsolute
        ? {as: 'a', href: url, target: '_blank', rel: 'noopener noreferrer'}
        : {as: Link, to: url}

    return (
        <Box {...styles.slideContainer} data-testid="insta-story-slide">
            {imageSrc && (
                <Box {...styles.slideImage}>
                    <Img
                        src={imageSrc}
                        alt={image?.alt || ''}
                        objectFit="cover"
                        w="100%"
                        h="100%"
                        className="slideimage"
                    />
                </Box>
            )}
            <Box {...styles.slideMask} />
            <Flex {...styles.slideButtonContainer}>
                {label && url && (
                    <Button {...buttonProps} variant="primary" onClick={(e) => e.stopPropagation()}>
                        {label}
                    </Button>
                )}
            </Flex>
        </Box>
    )
}

InstaStorySlide.propTypes = {
    button: PropTypes.object,
    image: PropTypes.object,
    styles: PropTypes.object,
}

export default InstaStorySlide
